module.exports = __webpack_public_path__ + "img/app_02.ba9553ee.png";